<div class="organizations-container">
    <div class="page-top-banner">
        <div class="title">
            Partenaires
        </div>

        <div class="action-zone">
            <mat-button-toggle-group class="accent-button" #group="matButtonToggleGroup" value="table"
                class="accent-button">
                <mat-button-toggle value="table" matTooltip="{{ 'Organizations.ListView'}}">
                    <mat-icon>table_rows</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle value="tree" matTooltip="{{ 'Organizations.TreeView' }}">
                    <mat-icon>account_tree</mat-icon>
                </mat-button-toggle>
            </mat-button-toggle-group>

            <!-- matTooltip="{{'Organizations.ButtonOrganizationCreationTooltip'|translate}}" -->
            <button mat-icon-button class="accent-button" routerLink="/management/organization">
                <mat-icon>add</mat-icon>
                <span class="text-button">Créer un partenaire</span>
            </button>
        </div>
    </div>

    @if (group.value === 'table') {
    <div class="table-container">
        <form class="filters-form" [formGroup]="filtersForm">
            <div class="mat-elevation-z8, general-table">
                <table mat-table class="default-table" [dataSource]="dataSource" matSort>
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Organizations.ColumnHeaderId'}}</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="id" (keyup)="applyFilters()" autocomplete="off" />
                                    <button mat-icon-button matSuffix matTooltip="Réinitialiser le filtre"
                                        (click)="resetColumnFilter('id')" type="button">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                    </ng-container>
                    <ng-container matColumnDef="display">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Nom</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="display" (keyup)="applyFilters()"
                                        autocomplete="off" />
                                    <button mat-icon-button matSuffix class="accent-buttonmat-accent search-icon"
                                        matTooltip="Réinitialiser le filtre" (click)="resetColumnFilter('display')"
                                        type="button">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.display }}</td>
                    </ng-container>
                    <ng-container matColumnDef="displayParentOrganization">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Partenaire parent</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="displayParentOrganization" (keyup)="applyFilters()"
                                        autocomplete="off" />
                                    <button mat-icon-button matSuffix class="accent-button mat-accent search-icon"
                                        matTooltip="Réinitialiser le filtre"
                                        (click)="resetColumnFilter('displayParentOrganization')">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.displayParentOrganization }}</td>
                    </ng-container>
                    <ng-container matColumnDef="billing">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Code de facturation</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="billing" (keyup)="applyFilters()"
                                        autocomplete="off" />
                                    <button mat-icon-button matSuffix class="accent-button mat-accent search-icon"
                                        matTooltip="Réinitialiser le filtre" (click)="resetColumnFilter('billing')">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.billing }}</td>
                    </ng-container>
                    <!-- <ng-container matColumnDef="enabled">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'Organizations.ColumnHeaderEnabled'|translate}} </th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox [checked]="element.enabled" [disabled]="true"></mat-checkbox>
              </td>
            </ng-container> -->
                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Date de création</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [matDatepicker]="datepicker" formControlName="createdAt"
                                        (dateChange)="applyFilters()" autocomplete="off" />
                                    <div matSuffix style="display: flex">
                                        <mat-datepicker-toggle class="mat-accent search-icon"
                                            [for]="datepicker"></mat-datepicker-toggle>
                                        <mat-datepicker #datepicker></mat-datepicker>
                                        <button mat-icon-button class="accent-button mat-accent search-icon"
                                            matTooltip="Réinitialiser le filtre"
                                            (click)="resetColumnFilter('createdAt')">
                                            <mat-icon>clear</mat-icon>
                                        </button>
                                    </div>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.createdAt }}</td>
                    </ng-container>
                    <ng-container matColumnDef="actions" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef>
                            <button mat-icon-button class="accent-button" matSuffix
                                matTooltip="Réinitialiser tous les filtres" (click)="resetAllColumnFilter()">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="actions-cell">
                                <button mat-icon-button routerLink="/management/organization"
                                    [queryParams]="{ id: element.id }">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                                <button mat-icon-button (click)="onDeleteClick(element.display, element.id)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
                <mat-paginator class="default-paginator" [pageSizeOptions]="[10]"></mat-paginator>
            </div>
        </form>
    </div>
    }
    @if (group.value === 'tree') {
    <div class="treeview">
        <mat-tree [dataSource]="treeDataSource" [treeControl]="treeControl">
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                <button class="button-tree" mat-button routerLink="/management/organization"
                    [queryParams]="{ id: node.id }">
                    <mat-icon>corporate_fare</mat-icon>
                    <span>{{ node.name }}</span>
                </button>
            </mat-tree-node>
            <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                <button mat-icon-button matTreeNodeToggle>
                    <mat-icon class="mat-icon-rtl-mirror">
                        {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                </button>
                <button class="button-tree" mat-button routerLink="/management/organization"
                    [queryParams]="{ id: node.id }">
                    <mat-icon>corporate_fare</mat-icon>
                    <span>{{ node.name }}</span>
                </button>
            </mat-tree-node>
        </mat-tree>
    </div>
    }
</div>

<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.2)" size="medium" color="#00D2B4" type="timer"
    [fullScreen]="false"></ngx-spinner>